import React, { FC, useEffect } from 'react'
import { Card, ScheduleCard } from 'components/Card'
import { BreadType } from 'types/bread'
import { useDispatch, useSelector } from 'react-redux'
import { getStocks } from 'reducks/stock/selectors'
import { State } from 'index'
import { fetchFutureStocks } from 'reducks/stock/operations'
import { getStoreRef } from 'reducks/auth/selectors'
import { StockUnionType } from 'types/stock'
import { getBreadShortName } from 'lib/helper'

type Props = {
  breads: BreadType[]
  type: StockUnionType
}

const ScheduleCardList: FC<Props> = (props) => {
  const { breads, type } = props
  const dispatch = useDispatch()
  const stocks = useSelector((state: State) => getStocks(state))
  const storeRef = useSelector((state: State) => getStoreRef(state))
  useEffect(() => {
    if (!storeRef) return
    dispatch(fetchFutureStocks({ storeRef, types: [type] }))
  }, [storeRef, type])
  return (
    <Card>
      {breads.map((bread) => {
        if (!bread.bread_ref) return
        const _stocks = stocks.filter((stock) => stock.bread_ref.id === bread.bread_ref?.id)
        const hasStocks = _stocks.length > 0
        return (
          <ScheduleCard
            key={bread.bread_ref.id}
            bread={bread}
            breadName={getBreadShortName(bread)}
            breadRef={bread.bread_ref}
            imageUrl={bread.image_urls[0] || ''}
            hasStocks={hasStocks}
            type={type}
          />
        )
      })}
    </Card>
  )
}

export default ScheduleCardList
